import React from 'react'
import { useTranslation } from 'react-i18next'
import VerificationInput from 'react-verification-input'
import { useFormikContext } from 'formik'
import { Code } from 'src/components/Forgot/StepTwo/styles'

const StepTwo: React.FC = () => {
  const { t } = useTranslation()
  const formik = useFormikContext()
  return (
    <>
      <div className="step-header">
        <h1>{t('forgot.stepTwo.title')}</h1>
        <p>{t('forgot.stepTwo.desc')}</p>
      </div>

      <Code>
        <VerificationInput
          validChars="0-9"
          inputProps={{ type: 'tel' }}
          onChange={e => formik.setFieldValue('token', e)}
          classNames={{
            container: 'container',
            character: 'character',
            characterInactive: 'character--inactive',
            characterSelected: 'character--selected',
          }}
        />
      </Code>
    </>
  )
}

export default StepTwo
